<template>
  <div class="evento-etapa-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Etapa">
          <b-table 
              class="datos-objeto" 
              responsive="sm" 
              :items="eventoEtapaDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'eventoEtapa/getField',
  mutationType: 'eventoEtapa/updateField',
});

export default {
  name: 'EventoEtapaDatos',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      eventoEtapaId: 0,
      
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ]
    }
  },
  computed: {
    ...mapFields([
      'eventoEtapaDatos',
    ]),
  },
  created() {
    let eventoEtapaId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
      if (this.$route.params.id){
        eventoEtapaId = this.$route.params.id;
      }
    }

    let params = {
      eventoId: this.eventoId,
      eventoEtapaId
    }

    this.showSpinner();
    this.$store.dispatch('eventoEtapa/getDatos', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
  }   
}
</script>

<style>
  .evento-etapa-datos .datos-objeto table td[aria-colindex="1"] {
    width: 20%;
  }
  .evento-etapa-datos .datos-objeto table td[aria-colindex="2"] {
    width: 80%;
  }
</style>